import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as Yup from 'yup';
import { addBusinessDays } from 'date-fns';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { DateTime, getBaseSchema as getDateTimeBaseSchema, getInitialValues } from './DateTime';
import { jsx as _jsx } from "react/jsx-runtime";
export var getDateTimeInitialValues = function getDateTimeInitialValues(dateTimeAnswer) {
  var _dateTimeAnswer$answe;

  return getInitialValues(dateTimeAnswer === null || dateTimeAnswer === void 0 ? void 0 : (_dateTimeAnswer$answe = dateTimeAnswer.answeredDateTime) === null || _dateTimeAnswer$answe === void 0 ? void 0 : _dateTimeAnswer$answe.seconds);
};
export var getDateTimeValidationSchema = function getDateTimeValidationSchema(isOptional, t) {
  var baseSchema = getDateTimeBaseSchema(t, false);
  var baseSchemaRequired = getDateTimeBaseSchema(t, true);
  return Yup.object().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: baseSchema,
    otherwise: isOptional ? baseSchema : baseSchemaRequired
  });
};
export var DateTimeElement = function DateTimeElement(_ref) {
  var _values$questionId;

  var instructionHint = _ref.instructionHint,
      dateTimeAnswer = _ref.dateTimeAnswer,
      formikProps = _ref.formikProps,
      isDisabled = _ref.isDisabled,
      id = _ref.id;
  var values = formikProps.values,
      setFieldValue = formikProps.setFieldValue;

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  return /*#__PURE__*/_jsx(DateTime, {
    id: id,
    values: values === null || values === void 0 ? void 0 : (_values$questionId = values[questionId]) === null || _values$questionId === void 0 ? void 0 : _values$questionId[index],
    setValues: function setValues(value) {
      return setFieldValue(id, value);
    },
    instructionHint: instructionHint,
    inputFieldHint: dateTimeAnswer === null || dateTimeAnswer === void 0 ? void 0 : dateTimeAnswer.inputFieldHint,
    inputFieldHintTime: dateTimeAnswer === null || dateTimeAnswer === void 0 ? void 0 : dateTimeAnswer.inputFieldHintTime,
    minDate: addBusinessDays(new Date(), 3),
    isDisabled: isDisabled
  });
};